<template>
  <div class="banner-type mx-2 rounded px-2 py-1 d-flex">
    <IconShootingType :type="type" />
    <span v-if="count" class="ml-1">{{ count }}</span>
  </div>
</template>

<script>
import IconShootingType from '@/components/common/atoms/IconShootingType'

export default {
  name: 'BannerIconShootingType',

  components: {
    IconShootingType
  },

  props: {
    type: {
      type: String,
      default: '',
      require: true
    },
    count: {
      type: Number
    }
  }
}
</script>

<style lang="sass" scoped>
.banner-type
    position: absolute


    z-index: 1
    background-color: white
</style>
